import type { ApiClient } from './client';
import type { ConversationTagRef } from './conversations';

// ANX-043 — CRUD tag'ов диалога + assign/unassign под operator-auth.

export type ConversationTag = ConversationTagRef;

interface RawList {
  conversation_tags: ConversationTagRef[];
}

export async function listConversationTags(client: ApiClient): Promise<ConversationTag[]> {
  const raw = await client.request<RawList>('/api/v1/conversation_tags');
  return raw.conversation_tags;
}

export async function createConversationTag(
  client: ApiClient,
  input: { name: string; color: string },
): Promise<ConversationTag> {
  return client.request<ConversationTag>('/api/v1/conversation_tags', {
    method: 'POST',
    json: input,
  });
}

export async function updateConversationTag(
  client: ApiClient,
  id: string,
  input: { name?: string; color?: string },
): Promise<ConversationTag> {
  return client.request<ConversationTag>(`/api/v1/conversation_tags/${id}`, {
    method: 'PATCH',
    json: input,
  });
}

export async function deleteConversationTag(client: ApiClient, id: string): Promise<void> {
  await client.request<void>(`/api/v1/conversation_tags/${id}`, { method: 'DELETE' });
}

export async function assignTagToConversation(
  client: ApiClient,
  conversationId: string,
  tagId: string,
): Promise<void> {
  await client.request<void>(`/api/v1/conversations/${conversationId}/tags/${tagId}`, {
    method: 'POST',
  });
}

export async function unassignTagFromConversation(
  client: ApiClient,
  conversationId: string,
  tagId: string,
): Promise<void> {
  await client.request<void>(`/api/v1/conversations/${conversationId}/tags/${tagId}`, {
    method: 'DELETE',
  });
}
